export enum MediaBankReferenceType {
    Default = 0,
    Original = 1,
}
